import { observer } from 'mobx-react-lite';
import { AnimatePresence } from 'framer-motion';

import { useMemo } from 'react';
import { useCommentStore } from '../CommentContext';
import Comment from '../Comment/Comment';
import { CommentListWrapper } from './CommentList.styles';

function CommentList({
  className,
  grayInput,
}: {
  className?: string;
  grayInput?: boolean;
}): JSX.Element {
  const commentStore = useCommentStore();
  const comments = useMemo(() => commentStore?.comments?.slice().reverse(), [
    commentStore?.comments,
  ]);
  const commentsLength = comments?.length || 0;
  if (!commentsLength) return null;

  const lastIdx = commentsLength - 1;

  return (
    <CommentListWrapper>
      <AnimatePresence>
        {comments.map((comment, idx) => (
          <Comment
            key={comment.id}
            comment={comment}
            className={className}
            lastItem={idx === lastIdx}
            grayInput={grayInput}
          />
        ))}
      </AnimatePresence>
    </CommentListWrapper>
  );
}

CommentList.defaultProps = {
  className: '',
};

export default observer(CommentList);
